import { BaseAssetPath } from '@/common'
import { AscendancyDefinition, CharacterDefinition } from '@/data/types'

import classNames from 'classnames'
import styles from './images.module.scss'

export function ascendancyColor(asc: AscendancyDefinition) {
  if (!asc.flavour_text) return `192,192,192`
  return asc.flavour_colour
}

export function classColor(chr: CharacterDefinition) {
  let r = 0,
    g = 0,
    b = 0,
    count = 0
  for (const asc of Object.values(chr.ascendancies)) {
    const colors = ascendancyColor(asc).split(',').map(Number)
    r += colors[0]
    g += colors[1]
    b += colors[2]
    count += 1
  }
  if (!count) return '255,255,255'
  return [r, g, b].map((v) => Math.round(v / count)).join(',')
}

const createSlug = (name: string) => name.toLowerCase().split(' ').join('-')
export const characterImage = (name: string) => `${BaseAssetPath}/images/poe/ascendancy/${createSlug(name)}.webp`
export const characterBkgImage = (name: string) => `${BaseAssetPath}/images/poe/ascendancy-bkg/${createSlug(name)}.webp`
// export const characterImage = (name: string) => getAssetsPath(`ascendancy/${createSlug(name)}.webp`)
// export const characterBkgImage = (name: string) => getAssetsPath(`ascendancy-bkg/${createSlug(name)}.webp`)

export function GenericBackground({ className }: { className?: string }) {
  return (
    <div
      style={{
        backgroundImage: `linear-gradient(90deg, rgb(10, 10, 10) 5%, transparent 10%), url("${BaseAssetPath}/images/poe2/build-guides/poe2-passives-2.webp")`
      }}
      className={classNames(styles.GenericBackground, className)}></div>
  )
}

export function ClassBackground({ name, className }: { name?: string; className?: string }) {
  return name ? (
    <div
      style={{
        backgroundImage: `linear-gradient(90deg, #0a0a0a 0%, transparent 50%, #0a0a0a 100%), url("${characterBkgImage(
          name
        )}")`
      }}
      className={classNames(styles.ClassBackground, className)}></div>
  ) : null
}

export function ClassIcon({ name, size = 48, className }: { name: string; size?: number; className?: string }) {
  return (
    <div
      className={classNames(styles.ClassIcon, className)}
      style={{
        backgroundImage: `url("${characterImage(name)}")`,
        fontSize: size
      }}
    />
  )
}
